import React from 'react';
import SeoHead from '../../../shared/seo/SeoHead';
import { TestimonialsPublic } from '../components/TestimonialsPublic';

/**
 * Standalone public /testimonials page.
 * Wraps the reusable TestimonialsPublic section (also shown on the homepage)
 * with its own SEO head so the URL referenced in robots.txt, llms.txt and
 * the sitemap resolves to a real, indexable page instead of the 404 route.
 */
const TestimonialsPage: React.FC = () => (
    <>
        <SeoHead
            title="Customer Testimonials | Arte Craft India"
            description="Read reviews and feedback from fashion brands, home-decor companies and craft businesses worldwide who source handcrafted pom poms, tassels, fringes and beaded patches from Arte Craft India."
            keywords="Arte Craft India reviews, customer testimonials, B2B buyer feedback, pom poms supplier reviews, tassels manufacturer testimonials"
            canonical="https://www.artecraftindia.com/testimonials"
            ogUrl="https://www.artecraftindia.com/testimonials"
            ogImage="https://www.artecraftindia.com/images/homepage-og.jpg"
        />
        <TestimonialsPublic />
    </>
);

export default TestimonialsPage;
